import axios from 'axios'
// import {getToken} from "../../../../web-authentication-sdk/src/helper" 
import trackEvent from '../../../../client/helpers/trackAnalytics'
import localforage from 'localforage'
// import { dynamicConfig } from '../../../../../components/DynamicRoutes'
// import { subscriptionStore } from '../../Api'
import pubsub from "@viewlift/pubsub"
// import { handleUserTransactions } from '../../../../../helpers'
let xApikey = window?.xApiKey
let apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl
let site =  window?.app_data?.site?.siteInternalName
// import { callRequest } from '../../../../../Graphql/request'
import { parseJSON } from '../../utils/parseJSON'
import { fetchUserDetails, getDeviceId, getToken, handleStatusGaCalls } from '../../../helpers'
import { callRequest } from '../../../Graphql/request'
import { publishPaymentStatusPopup, publishTransactionStatus, publishUpgradeSubscription } from '../../Events/monetisation.events'
import { publishAppLoading, publishErrorUpdate } from '../../Events/utils.events'
import { FB_EVENTS } from '../../../helpers/analyticsMap'
import { ANALYTICSEVENTS } from '../../LoginV2/Helpers/analyticsMap'
import { fetchCurrentPlan } from '../../PlansWrapper/helper'
import { flowSteps } from '../../helper'
import { publishHBAModal } from '../../Events/hba.events'

export const fetchUserObject = async () => {
  const AuthenticationStore = await localforage.getItem('AuthenticationStore')
  let user = AuthenticationStore?.user
  return user
}

export const getBillingToken = async (stripeToken, stripeRef,cardElement,addressElement) => {

  let enableAddressForm = window?.app_data?.appcmsMain?.paymentProviders?.stripe?.showPaymentAddress
  const updateCard = parseJSON(sessionStorage.getItem('updateCardStatus'));
    let user = await fetchUserObject() //user
    let token = await getToken(token => {return token})
    let intentObj = await setupIntent();
    let addressDetails = {}
    if (enableAddressForm && !updateCard) {
      addressDetails = await addressElement.getValue()
    }
    var confirmIntentObj = await stripeRef.handleCardSetup(intentObj.data && intentObj.data.client_secret,cardElement,{
      payment_method_data: {
        billing_details: {
          "address": addressDetails?.value?.address || {},
          "name": stripeToken.token.card.name
        }
      }
    })

    if(confirmIntentObj.error) {
      publishHBAModal(false)
      publishAppLoading(false)
      publishErrorUpdate(confirmIntentObj.error.message)
      throw new Error(confirmIntentObj.error.message)
    }
    try {
      var r = await validate_stripe_customer(token, confirmIntentObj, stripeToken, user,addressDetails);
      var status = r.data.cardStatus;
      if (status.cvc_check !== 'pass' && status.cvc_check !== 'unavailable' && status.cvc_check !== 'unchecked')
        throw new Error({
          'message': 'Your CVC is invalid'
        })
    }
    catch (err) {
      publishHBAModal(false)
      publishAppLoading(false)
      publishErrorUpdate(err.message)
      throw new Error(err.message)
    }
    return {
      stripeToken: stripeToken,
      requestId: r.data.requestId
    }
  }

async function setupIntent() {
  let token = await getToken(token => {return token})
    return axios({
    method: 'POST',
    url: `${apiBaseUrl}/payments/stripe/setup_intent`,
    data: {},
    headers: {
      'Authorization': token,
      'x-api-key': xApikey
    },
    params: {
      site: site
    }
})
}

function validate_stripe_customer(token, confirmIntentObj, stripeToken, user,addressDetails) {
  let enableAddressForm = window?.app_data?.appcmsMain?.paymentProviders?.stripe?.showPaymentAddress
  let data = { 
    token: stripeToken.token.id, 
    email: user && user.email, 
    paymentMethodId: confirmIntentObj.setupIntent && confirmIntentObj.setupIntent.payment_method,
  }
  const updateCard = parseJSON(sessionStorage.getItem('updateCardStatus'));
  if (enableAddressForm && !updateCard) {
    data.address = addressDetails.value.address
  }
  return axios({
    url: `/payments/stripe/validate_stripe_customer`,
    baseURL: apiBaseUrl,
    method: 'POST',
    params: { site: site, platform: 'web_browser' },
    headers: { 
      'Authorization': token,
      'x-api-key': xApikey
    },
    data: data
  })
}


export const subscribe = async (o) => {
  let { userId, user, hba } = await fetchUserDetails()
  let subscription = user?.isSubscribed || o?.isUpgrade
  let currentStatus = null
    if(subscription) {
      subscription = JSON.parse(subscription)
      currentStatus = user?.subscription?.subscriptionStatus
    }
    const stripe = o.billingToken && o.billingToken
      let data = {
        subscription: o.subscription || 'stripe',
        siteId: window?.app_data?.appcmsMain?.id,
        platform: 'web_browser',
        planId: o?.plan?.planId || o?.plan?.id,
        planIdentifier: o.plan.identifier,
        userId: userId,
        currencyCode:  o?.plan?.currency,
        appliedOffers: o.offerCode ? [ o.offerCode ] : null,
        ...(stripe && {
          stripeToken: o.billingToken.stripeToken.token.id || o.billingToken.stripeToken.token.card.id,
          requestId: o.billingToken.requestId || o.billingToken.stripeToken.token.card.requestId,
        }),
      }
    let variables = {
      site,
      req :{
        stripe : data
      }
    }

    //HBA Inputs
    variables.req.hba = {
      enabled : hba?.enabled,
      latitude : hba?.latitude,
      longitude : hba?.longitude
    }

    let cb = () => {}
    return callRequest({type : "intiateSubscription", variables,cb}).then(async (res) => {
      publishPaymentStatusPopup({status : res?.createAccountAndSubscription?.subscriptionStatus, requestId: o.billingToken.requestId || o.billingToken.stripeToken.token.card.requestId})
    }).catch((e) => {
      if (e) {
        publishPaymentStatusPopup({status : false, requestId: o.billingToken.requestId || o.billingToken.stripeToken.token.card.requestId})
      }
    })
}

const transaction = async (data) => {
  let token = await getToken(token => {return token})
  return axios({
    method: 'POST',
    url: `${apiBaseUrl}/transaction/transaction`,
    headers: {
      Authorization: token,
      'x-api-key': xApikey
    },
    data: data
  })
}
export const purchase = async (o, transactionData) => {
  let user = await fetchUserObject()
  let contentDetails = transactionData?.contentDetails
  const isEpisode = () => contentDetails?.gist?.contentType === "SERIES"
  const data={}
  data.amount = transactionData?.planDetails?.amount
  data.offerCode = o.offerCode ? [ o.offerCode ] : undefined
  data.transaction = o.subscription || 'stripe',
  data.stripeToken = o.billingToken.stripeToken.token.id || o.billingToken.stripeToken.token.card.id
  data.contentRequest = {
    contentType: contentDetails?.gist?.contentType,
    contentId: contentDetails?.id,
    videoIds: contentDetails?.id,
    seriesId: isEpisode() ? contentDetails?.id : null,
    videoQuality: 'HD'
  }
  data.purchaseType = transactionData?.purchaseType === "Buy" ? "PURCHASE" : transactionData?.purchaseType?.toUpperCase()
  data.platform = "web_browser"
  data.siteId = window?.app_data?.appcmsMain?.id
  data.currencyCode = o?.plan?.planDetails?.[0]?.recurringPaymentCurrencyCode || o?.plan?.plansDetail?.recurringPaymentCurrencyCode || '';
  data.requestId = o.billingToken.requestId || o.billingToken.stripeToken.token.card.requestId;
  data.userId = user.userId
  data.email = user.email
  data.site = site
  data.planId = o.plan.id
  data.monetizationModel = "TVOD"
  transaction(data).then((res)=>{
    publishTransactionStatus({status: true})
  }).catch(err =>{
    publishTransactionStatus({status: false})
    pubsub.publish("purchaseError", true)
    pubsub.publish('isLoading', false)
    pubsub.publish('processing', false)
    // pubsub.publish('purchase-status',{success : false, data : {handleRoute,navigateRef}})
  })
}

//GA functions

export const addPaymentInfo = (plan,offerCodeDetails) => {
  trackEvent("add_payment_info", {
    currency: plan && plan.plansDetail && plan.plansDetail.recurringPaymentCurrencyCode,
    coupon: offerCodeDetails?.code || offerCodeDetails || null,
    payment_type: "Card",
     items: [
      {
        item_id:  plan?.planId,
        item_name: plan?.title,
        coupon: offerCodeDetails?.code || offerCodeDetails || null,
        price: plan?.plansDetail?.recurringPaymentAmount,
        quantity: 1
      }
    ],
  },null)
}
export const purchaseEvent = async (plan,offerCodeDetails,token) => {
  let { userId } = await fetchUserDetails()
  let planDetails = plan?.plansDetail
  localforage.getItem('transactionData').then((transactionData) => {
    let isTvod = transactionData?.isPurchase
    let payload = {
      transaction_id: token?.token?.id || "",
      currency: plan && plan.plansDetail && plan.plansDetail.recurringPaymentCurrencyCode,
      coupon: offerCodeDetails?.code || offerCodeDetails || null,
      payment_type: "Card",
       items: [
        {
          item_id: plan?.planId,
          item_name: plan?.title,
          coupon: offerCodeDetails?.code || offerCodeDetails || null,
          price: planDetails?.recurringPaymentAmount,
          quantity: 1,
          userId
        }
      ],
    }

  if (isTvod) {
    payload.items.price = planDetails?.isRentEnabled ? planDetails?.rentAmount : planDetails?.purchaseAmount
  }
  trackEvent("purchase",payload,null)
  })
}

export const success = (status,plan) => {
  let planDetails = plan?.planDetails.length && plan.planDetails[0]
    let payload = {
        paymentPlan: plan?.name,
        country: planDetails?.countryCode,
        value: planDetails?.recurringPaymentAmount,
        currency : planDetails?.recurringPaymentCurrencyCode
    }
  if(status === 'InProcess'){
    pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.PAYMENT_PENDING,data:plan});
  }else if(status === 'Success'){
    pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.PAYMENT_SUCCCESS,data:plan});
    handleSubscriptionAnalytics("FB",FB_EVENTS.SUBSCRIPTION_COMPLETED,payload)
    handleSubscriptionAnalytics("PIXEL",pixel_Events.SUBSCRIPTION_COMPLETED,{
      value: payload.value,
      currency: payload.currency
    })
  }else if(status === 'Failed'){
    pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.PAYMENT_FAILURE,data:plan});
    handleSubscriptionAnalytics("FB",FB_EVENTS.SUBSCRIPTION_FAILED,payload)
    setIsError(true)
  }
  setSuscribeStatus(status)
  pubsub.publish('isLoading', false)
  pubsub.publish('processing', false)
}

export const upgradePlan = async (o) => {
  publishAppLoading(true)
  let token = await getToken(token => {return token})
  let { userId,user } = await fetchUserDetails()
  let subscriptionId = user?.subscription?.subscriptionInfo?.id
    let method = "PUT" 
    let data = o?.data
    return axios({
      method: method,
      url: `${apiBaseUrl}/subscription/subscribe`,
      params: { platform: 'web_browser', site: site },
      headers: { 
        Authorization: token,
        'x-api-key':xApikey
      },
      data: data
    }).then(async (res) => { 
      publishUpgradeSubscription(true)
      handleStatusGaCalls({eventName : 'update_subscription',subSection : null, type : 'updateSubscription', reason : subscriptionId, status : data?.planId ,additionalLabel : null, action : 'Update', paymentStatus : null,eventCategory : 'Subscription',section : 'Subscription'})
        return res
  }).catch((err) => {
    publishUpgradeSubscription(false)
  })
}

export const checkoutSuccessEvent = () => {
  let plan = fetchCurrentPlan()
  let isCheckoutPage = window.location.pathname == '/checkout' ? window.location.origin : window.location.href
  const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
  let obj = {
    "pageUrl": checkoutInitPageDetails?.pageUrl,
    "pgName": checkoutInitPageDetails?.pgName,
    "pgId": checkoutInitPageDetails?.pgId,
    "LandingPage": isCheckoutPage,
    "monetizationType": plan?.type,
    "stepsCompleted":flowSteps
  }
  return obj
}

export const checkoutFailureEvent = () => {
  let plan = fetchCurrentPlan()
  const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
  let obj = {
    "pageUrl": checkoutInitPageDetails?.pageUrl,
    "pgName": checkoutInitPageDetails?.pgName,
    "pgId": checkoutInitPageDetails?.pgId,
    "monetizationType": plan?.type,
    "stepsCompleted": flowSteps,
  }
  return obj
}